import request from 'utils/request'
/*---------  客户管理中心详情    -------*/
//客户概览
export const getCustomerOverview = id =>
  request().get(`customer/overview/${id}`)
//客户概览
export const getCustomerOverviewSegment = id =>
  request().get(`customer/overview/segment/${id}`)
//发送邮箱
export const sendEmail = id => request().get(`customer/overview/toEmail/${id}`)
//生成pdf
export const overviewPdf = id =>
  request().get(`customer/overview/export/${id}`, { responseType: 'blob' })
// getinsCoverRate
export const getinsCoverRate = data =>
  request().post('customer/child/insCoverRate', data)
// 下载 文件uploadinsCoverRate
export const getuploadinsCoverRate = data =>
  request().post('customer/child/down/insCoverRate', data, {
    responseType: 'arraybuffer',
  })
